import React, { useEffect } from "react";
import { Button, Empty } from "antd";
import { useNavigate } from "react-router-dom";

import useJDStore from "../../store/jd.store";

import Table from "../Table";

import "./jdsDashboard.scss";
import useMembersStore from "../../store/members.store";

export default function JDsDashBoard(props) {

  const { jdData } = useJDStore();
  const { clients,getClients ,clientsFlag,resetClientsFlag } = useMembersStore();
  
  useEffect(() => {
    //getAllJds();
    getClients();
  }, []);
  useEffect(() => {
     if(clientsFlag)
        resetClientsFlag()
  }, [clientsFlag]);
  const customerList = [
    "Sr. No.",    
    "Client",
    "TA",
    "JD Todays",
    "JD Urgent",
    "JD High Priority",
    "JD Normal Priority",
    "JD Low Priority",
    "JD Open",
    "JD Hold",
    "JD Closed",
    "JD Expired",
  ];
 
  const customerUIData = [];

  function  copyData () {
    var idx=0;
    for (const client of clients) {
        if(client?.ClientTAList != null){
          for(const ta of client?.ClientTAList){
            if(ta?.TotalJDsOpen >0 || ta?.TotalJDsClosed>0 || ta?.TotalJDsHold>0){
              customerUIData.push({
                id: idx+1,
                clientName: client?.ClientName,
                taName: ta?.TAName,
                tpr: ta?.TotalJDsT,              
                upr: ta?.TotalJDsU,              
                hpr: ta?.TotalJDsH,
                npr: ta?.TotalJDsN,              
                lpr: ta?.TotalJDsL,
                jdsopen: ta?.TotalJDsOpen,
                jdshold: ta?.TotalJDsHold,                
                jdsclosed: ta?.TotalJDsClosed,
                jdexpired: ta?.TotalJDsExpired
              });
            }
      }
    }
  }
}

  return (
    <div className="jds-wrapper">
      {copyData()}
      {jdData?.length > 0 ? (
           <Table
            isClickable={false}
            isJDPage={false}
            titleList={customerList}
            data={customerUIData}
            columnWidth={[50, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,100]}
          />             
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}
    </div>
  );
}
